// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const CalculationMethods = {
  Dgbc: "dgbc",
} as const;
export type CalculationMethods = (typeof CalculationMethods)[keyof typeof CalculationMethods];

export function instanceOfCalculationMethods(value: any): boolean {
  for (const key in CalculationMethods) {
    if (Object.prototype.hasOwnProperty.call(CalculationMethods, key)) {
      if (CalculationMethods[key as keyof typeof CalculationMethods] === value) {
        return true;
      }
    }
  }
  return false;
}

export function CalculationMethodsFromJSON(json: any): CalculationMethods {
  return CalculationMethodsFromJSONTyped(json, false);
}

export function CalculationMethodsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CalculationMethods {
  return json as CalculationMethods;
}

export function CalculationMethodsToJSON(value?: CalculationMethods | null): any {
  return value as any;
}

export function CalculationMethodsToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): CalculationMethods {
  return value as CalculationMethods;
}
